// Copyright (c) 2020-2023 dātma, inc™
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { annotationBaseUrl, biomarkerBaseUrl, omicsBaseUrl, omicsFastUrl, requestTimeout } from '@/settings'
import { getRandomArbitrary } from '@/utils/utils'

const useDiagnosisWithTreatmentsTrialsRequests
  = store.getters.featureToggles.useDiagnosisWithTreatmentsTrialsRequests

const alterationsBaseUrl = `${annotationBaseUrl}/odaVEPAnnotationREST`
const treatmentsBaseUrl = `${annotationBaseUrl}/treatments`
const trialsBaseUrl = `${annotationBaseUrl}/trials`
const treatmentsCountUrl = `${treatmentsBaseUrl}/count`
const trialsCountUrl = `${trialsBaseUrl}/count`
const clinicalOmicsUrl = `${omicsFastUrl}/clinical`

const MAX_RETRIES = 25
const BACKOFF = 100 //ms
const CAP = 2000 //ms

const samplesQuery = 'samples'
// TODO: at some point we will have a queryAll parameter from the backend, so we won't need this giant string
const genes = 'ABL1,ABL2,ACVR1,ACVR1B,AKT1,AKT2,AKT3,ALK,ALOX12B,ANKRD11,ANKRD26,APC,AR,ARAF,ARFRP1,ARID1A,ARID1B,ARID2,ARID5B,ASXL1,ASXL2,ATM,ATR,ATRX,AURKA,AURKB,AXIN1,AXIN2,AXL,B2M,BAP1,BARD1,BBC3,BCL10,BCL2,BCL2L1,BCL2L11,BCL2L2,BCL6,BCOR,BCORL1,BCR,BIRC3,BLM,BMPR1A,BRAF,BRCA1,BRCA2,BRD4,BRIP1,BTG1,BTK,EMSY,CALR,CARD11,CASP8,CBFB,CBL,CCND1,CCND2,CCND3,CCNE1,CD274,CD276,CD74,CD79A,CD79B,CDC73,CDH1,CDK12,CDK4,CDK6,CDK8,CDKN1A,CDKN1B,CDKN2A,CDKN2B,CDKN2C,CEBPA,CENPA,CHD2,CHD4,CHEK1,CHEK2,CIC,CREBBP,CRKL,CRLF2,CSF1R,CSF3R,CSNK1A1,CTCF,CTLA4,CTNNA1,CTNNB1,CUL3,CUX1,CXCR4,CYLD,DAXX,DCUN1D1,DDR2,DDX41,DHX15,DICER1,DIS3,DNAJB1,DNMT1,DNMT3A,DNMT3B,DOT1L,E2F3,EED,EGFL7,EGFR,EIF1AX,EIF4A2,EIF4E,EML4,EP300,EPCAM,EPHA3,EPHA5,EPHA7,EPHB1,ERBB2,ERBB3,ERBB4,ERCC1,ERCC2,ERCC3,ERCC4,ERCC5,ERG,ERRFI1,ESR1,ETS1,ETV1,ETV4,ETV5,ETV6,EWSR1,EZH2,AMER1,ABRAXAS1,FAM46C,FANCA,FANCC,FANCD2,FANCE,FANCF,FANCG,FANCI,FANCL,FAS,FAT1,FBXW7,FGF1,FGF10,FGF14,FGF19,FGF2,FGF23,FGF3,FGF4,FGF5,FGF6,FGF7,FGF8,FGF9,FGFR1,FGFR2,FGFR3,FGFR4,FH,FLCN,FLI1,FLT1,FLT3,FLT4,FOXA1,FOXL2,FOXO1,FOXP1,FRS2,FUBP1,FYN,GABRA6,GATA1,GATA2,GATA3,GATA4,GATA6,GEN1,GID4,GLI1,GNA11,GNA13,GNAQ,GNAS,ADGRA2,GPS2,GREM1,GRIN2A,GRM3,GSK3B,H3F3A,H3F3B,H3F3C,HGF,HIST1H1C,HIST1H2BD,HIST1H3A,HIST1H3B,HIST1H3C,HIST1H3D,HIST1H3E,HIST1H3F,HIST1H3G,HIST1H3H,HIST1H3I,HIST1H3J,HIST2H3A,HIST2H3C,HIST2H3D,HIST3H3,HLA-A,HLA-B,HLA-C,HNF1A,HNRNPK,HOXB13,HRAS,HSD3B1,HSP90AA1,ICOSLG,ID3,IDH1,IDH2,IFNGR1,IGF1,IGF1R,IGF2,IKBKE,IKZF1,IL10,IL7R,INHA,INHBA,INPP4A,INPP4B,INSR,IRF2,IRF4,IRS1,IRS2,JAK1,JAK2,JAK3,JUN,KAT6A,KDM5A,KDM5C,KDM6A,KDR,KEAP1,KEL,KIF5B,KIT,KLF4,KLHL6,KMT2B,KMT2C,KMT2D,KRAS,LAMP1,LATS1,LATS2,LMO1,LRP1B,LYN,LZTR1,MAGI2,MALT1,MAP2K1,MAP2K2,MAP2K4,MAP3K1,MAP3K13,MAP3K14,MAP3K4,MAPK1,MAPK3,MAX,MCL1,MDC1,MDM2,MDM4,MED12,MEF2B,MEN1,MET,MGA,MITF,MLH1,KMT2A,MLLT3,MPL,MRE11,MSH2,MSH3,MSH6,MST1,MST1R,MTOR,MUTYH,MYB,MYC,MYCL,MYCN,MYD88,MYOD1,NAB2,NBN,NCOA3,NCOR1,NEGR1,NF1,NF2,NFE2L2,NFKBIA,NKX2-1,NKX3-1,NOTCH1,NOTCH2,NOTCH3,NOTCH4,NPM1,NRAS,NRG1,NSD1,NTRK1,NTRK2,NTRK3,NUP93,NUTM1,PAK1,PAK3,PAK5,PALB2,PRKN,PARP1,PAX3,PAX5,PAX7,PAX8,PBRM1,PDCD1,PDCD1LG2,PDGFRA,PDGFRB,PDK1,PDPK1,PGR,PHF6,PHOX2B,PIK3C2B,PIK3C2G,PIK3C3,PIK3CA,PIK3CB,PIK3CD,PIK3CG,PIK3R1,PIK3R2,PIK3R3,PIM1,PLCG2,PLK2,PMAIP1,PMS1,PMS2,PNRC1,POLD1,POLE,PPARG,PPM1D,PPP2R1A,PPP2R2A,PPP6C,PRDM1,PREX2,PRKAR1A,PRKCI,PRKDC,PRSS8,PTCH1,PTEN,PTPN11,PTPRD,PTPRS,PTPRT,QKI,RAB35,RAC1,RAD21,RAD50,RAD51,RAD51B,RAD51C,RAD51D,RAD52,RAD54L,RAF1,RANBP2,RARA,RASA1,RB1,RBM10,RECQL4,REL,RET,RFWD2,RHEB,RHOA,RICTOR,RIT1,RNF43,ROS1,RPS6KA4,RPS6KB1,RPS6KB2,RPTOR,RUNX1,RUNX1T1,RYBP,SDHA,SDHAF2,SDHB,SDHC,SDHD,SETBP1,SETD2,SF3B1,SH2B3,SH2D1A,SHQ1,SLIT2,SLX4,SMAD2,SMAD3,SMAD4,SMARCA4,SMARCB1,SMARCD1,SMC1A,SMC3,SMO,SNCAIP,SOCS1,SOX10,SOX17,SOX2,SOX9,SPEN,SPOP,SPTA1,SRC,SRSF2,STAG1,STAG2,STAT3,STAT4,STAT5A,STAT5B,STK11,STK40,SUFU,SUZ12,SYK,TAF1,TBX3,ELOC,TCF3,TCF7L2,TERC,TERT,TET1,TET2,TFE3,TFRC,TGFBR1,TGFBR2,TMEM127,TMPRSS2,TNFAIP3,TNFRSF14,TOP1,TOP2A,TP53,TP63,TRAF2,TRAF7,TSC1,TSC2,TSHR,U2AF1,VEGFA,VHL,VTCN1,WISP3,WT1,XIAP,XPO1,XRCC2,YAP1,YES1,ZBTB2,ZBTB7A,ZFHX3,ZNF217,ZNF703,ZRSR2'
const gfields = 'GT,REF,ALT,VP,VAF,NSA'

const callGenomicsREST = async (data, query, baseUrl) => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${baseUrl}?${query}=${encodeURIComponent(data)}&regions=${genes}&gfields=${gfields}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

/**
 *
 * @param {*} data
 * @param {*} query
 * @param {*} baseUrl
 * @returns
 *
 *
 * notes from oda_omics_frontend
 *
 * get alteration from VEPA query based on variant results
 * https://datma360.dev.datma.com/oda_annotation/odaVEPAnnotationREST?query=3-178952090-178952090-G-C-1,&transcriptset=0&mode=vep&disease=cancer
 * {"results":[{"name":"PIK3CA Gly1049Arg","exon":"21/21"}]}
 *
 * // the wild:
 * // var varlength = data[i]["start"] + Math.max(data[i]["Ref_allele"].length, allelearr[k].length) - 1;
 * // toAnnotate = toAnnotate + data[i]["contig"] + "-" + data[i]["start"] + "-" + varlength + "-" + data[i]["Ref_allele"] + "-" + allelearr[k] + "-1,";
 * // tbl_row.id = data[i]["contig"] + "-" + data[i]["start"] + "-" + varlength + "-" + data[i]["Ref_allele"] + "-" + allelearr[k] + "-1,";
 */

const callVEPAnnotation = async (data, query, baseUrl) => {
  const contig = data['contig']
  const start = data['start']
  const refAllele = data['Ref_allele']
  let altAllele = data['Alt_allele']
  altAllele = altAllele.replace(/\[/g, '')
  altAllele = altAllele.replace(/\]/g, '')
  const alleleArr = altAllele.split(',')

  //TODO: using 0 index on alleleArr likely isn't the way to go in the long run
  const varlength = start + Math.max(refAllele.length, alleleArr[0].length) - 1


  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${baseUrl}?${query}=${contig}-${start}-${varlength}-${refAllele}-${alleleArr[0]}-1,&transcriptset=0&mode=vep&disease=cancer`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

const callBiomarker = async (sample, marker, baseUrl) => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${baseUrl}?sample=${encodeURIComponent(sample)}&type=${marker}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

// Adapted from: https://dmitripavlutin.com/timeout-fetch-request/
export const fetchWithTimeoutOrCancel = async (controller, resource, options = {}) => {
  const { timeout = requestTimeout } = options

  const id = setTimeout(() => controller.abort(), timeout)
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  })
  clearTimeout(id)
  return response
}

// Adapted from https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
// Closest to Full Jitter
const backoffWithJitter = async (retryCounter) => {
  const backoffTime = getRandomArbitrary(BACKOFF, Math.min(CAP, BACKOFF * 2 ** retryCounter))
  // console.log('backoffTime: ', backoffTime)
  // const timerStart = performance.now()
  await new Promise((resolve) => setTimeout(resolve, backoffTime))
  // const timerEnd = performance.now()
  // console.log(`wait time for backoffWithJitter: ${timerEnd - timerStart} ms`)
}

const fetchWithRetriesOnError = async ({ controller, url, retryCounter, omicsValue }) => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const response = await fetchWithTimeoutOrCancel(controller, url, fetchParams)
    if (!response.ok) {
      console.log(`Doing a trial/thera retry fetch on a server error: status=${response.status}.`, retryCounter, omicsValue)
      if (retryCounter > MAX_RETRIES) { return [] }
      await backoffWithJitter(retryCounter)
      retryCounter++
      return fetchWithRetriesOnError({ controller, url, retryCounter, omicsValue })
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.error('Cancelled promises or timeout')
    } else if (e.name === 'SyntaxError') {
      // This syntax error seems to be peculiar to failure on the
      // treatments and trials annotation endpoints

      // TODO: this shouldn't be happening now since the service is now using a 500 error message in this case
      // but keep it in for now pending eventual removal
      console.log('Doing a trial/thera retry fetch on a parse JSON syntax error: ', e, retryCounter, omicsValue)
      if (retryCounter > MAX_RETRIES) { return [] }
      await backoffWithJitter(retryCounter)
      retryCounter++
      return await fetchWithRetriesOnError({ controller, url, retryCounter, omicsValue })
    } else {
      console.log('Doing a trial/thera retry fetch non-syntax/JSON error: ', e, retryCounter, omicsValue)
      if (retryCounter > MAX_RETRIES) { return [] }
      await backoffWithJitter(retryCounter)
      retryCounter++
      return await fetchWithRetriesOnError({ controller, url, retryCounter, omicsValue })
    }
  }
  return []
}

export const getVariantTrials = async ({
  age = -1,
  baseUrl,
  controller,
  disease,
  distance,
  gender = '',
  limit = 18,
  location,
  omicsType,
  omicsValue,
  sampleId = '',
  start = 0,
}) => {
  const diagnosisIfToggled = useDiagnosisWithTreatmentsTrialsRequests ? disease : ''
  const queryParams = new URLSearchParams({
    omics_type: omicsType,
    omics_value: omicsValue,
    disease: diagnosisIfToggled,
    distance,
    location,
    limit,
    start,
    sample_id: sampleId,
    age,
    gender: gender.toUpperCase(),
  })

  const retryCounter = 0
  const url = `${baseUrl}?${queryParams.toString()}`

  return await fetchWithRetriesOnError({ controller, url, retryCounter, omicsValue })
}

export const getVariantTherapies = async ({
  baseUrl,
  controller,
  disease,
  limit = 18,
  omicsType,
  omicsValue,
  start = 0,
}) => {
  const diagnosisIfToggled = useDiagnosisWithTreatmentsTrialsRequests ? disease : ''
  const queryParams = new URLSearchParams({
    omics_type: omicsType,
    omics_value: omicsValue,
    disease: diagnosisIfToggled,
    limit,
    start,
  })

  const retryCounter = 0
  const url = `${baseUrl}?${queryParams.toString()}`

  return await fetchWithRetriesOnError({ controller, url, retryCounter, omicsValue })
}
//Updated OmicsdsREST API
export const getClinicalOmics = async ({ controller, consequence = false, fastQuery = true, sampleId }) => {
  const queryParams = new URLSearchParams({
    consequence,
    fast_query: fastQuery,
  })

  if (Array.isArray(sampleId)) {
    sampleId.forEach((sample) => {
      queryParams.append('samples', sample.sample)
    })
  } else {
    queryParams.append('samples', sampleId)
  }

  const retryCounter = 0
  const url = `${clinicalOmicsUrl}?${queryParams.toString()}`

  return await fetchWithRetriesOnError({ controller, url, retryCounter, sampleId })
}

export const getTreatments = async ({ controller, diagnosis, limit = 18, omicsType, omicsValue, start = 0 }) =>
  await getVariantTherapies({ baseUrl: treatmentsBaseUrl, controller, disease: diagnosis, limit, omicsType, omicsValue, start })

export const getTreatmentsCount = async ({ controller, diagnosis, limit = 18, omicsType, omicsValue, start = 0 }) =>
  await getVariantTherapies({ baseUrl: treatmentsCountUrl, controller, disease: diagnosis, limit, omicsType, omicsValue, start })

export const getTrials = async ({ controller, diagnosis, distance, limit = 18, location, omicsType, omicsValue, sampleId, start = 0 }) =>
  await getVariantTrials({ baseUrl: trialsBaseUrl, controller, disease: diagnosis, distance, limit, location, omicsType, omicsValue, sampleId, start })

export const getTrialsCount = async ({ controller, diagnosis, distance, location, omicsType, omicsValue, sampleId, start = 0, limit = 18 }) =>
  await getVariantTrials({ baseUrl: trialsCountUrl, controller, disease: diagnosis, distance, limit, location, omicsType, omicsValue, sampleId, start })

export const getVariants = async (sampleId) =>
  await callGenomicsREST(sampleId, samplesQuery, omicsBaseUrl)

export const getAlterations = async (variantData) =>
  await callVEPAnnotation(variantData, 'query', alterationsBaseUrl)

export const getTmbMsi = async (sample, marker) =>
  await callBiomarker(sample, marker, biomarkerBaseUrl)

export const getFusions = async (sampleId) =>
  await callBiomarker(sampleId, 'FUSION', biomarkerBaseUrl)

export const getRnaAnnotation = async (sampleId) =>
  await callBiomarker(sampleId, 'RNA_ANNOTATION', biomarkerBaseUrl)

export const getCopyNumber = async (sampleId) =>
  await callBiomarker(sampleId, 'COPY_NUMBER_VARIATION', biomarkerBaseUrl)

export const getHla = async (sampleId) =>
  await callBiomarker(sampleId, 'GENEMARKER', biomarkerBaseUrl)


export const getEncryptedUrl = async () => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${annotationBaseUrl}/encrypted-url`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

export const getSearchKey = async (disease, distance, location, omics_value) => {
  const queryParams = new URLSearchParams({
    disease,
    distance,
    location,
    omics_value,
  })
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${annotationBaseUrl}/search-key?${queryParams.toString()}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
